<template>
  <div class="flex flex_col qxapage">
    <!-- 上面的选择 -->
    <div class="selects">
      <el-form
        :model="queryParam"
        ref="ruleform"
        :inline="true"
        class="flex flex_ju_sb warnform-inline"
      >
        <div class="form-inputs">
          <el-form-item
            label="选择生产区域"
            style="margin-bottom: 0; margin-right: 10px"
            v-if="isShowAllSelect"
          >
            <el-select
              v-model="allOrgId"
              :placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
              @change="changeAllOrg"
            >
              <el-option
                v-for="(item, index) in orgAllSelect"
                :key="index"
                :value="item.orgId"
                :label="item.orgName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="isShowAllSelect ? '' : '选择气象站'">
            <el-select
              :placeholder="orgSelect.length ? '请选择' : '暂无设备'"
              v-model="queryParam.deviceCode"
              @change="nowSBNameChange"
            >
              <el-option
                v-for="(item, index) in orgSelect"
                :key="index"
                :value="item.facId"
                :label="item.facName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择参数">
            <el-select
              placeholder="请选择"
              v-model="queryParam.list"
              :multiple="true"
              :multiple-limit="3"
              collapse-tags
            >
              <el-option
                v-for="(item, index) in itemSelect"
                :key="index"
                :label="item.itemName"
                :value="item.itemCode"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="时间区间" class="form-picker">
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.startTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions0"
                :editable="false"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>

            <span class="pick-word">至</span>
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.endTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions1"
                :editable="false"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>
          </el-form-item>
        </div>

        <el-form-item class="form-btns">
          <el-button type="primary" @click="searchClick_">查询</el-button>
          <el-button type="primary" @click="exportDownLoad">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 下面的折线图 -->
    <div class="flex flex_col chart-all" v-loading="loading">
      <!-- 导出按钮 -->
      <div class="flex flex_a_c flex_ju_c btn-export" v-show="isLine">
        <!-- <div @click="exportDownLoad">
          <img src="../../assets/image/analysis/icon_export.png" alt="" />
        </div> -->
        <div @click="toChart">
          <img
            :src="
              isEchart
                ? require('../../assets/image/analysis/icon_totable.png')
                : require('../../assets/image/analysis/icon_tochart.png')
            "
            alt=""
          />
        </div>
      </div>
      <!-- 图表 -->
      <div v-if="isLine" style="flex: 1">
        <div v-if="isEchart" style="height: 100%">
          <div class="chart-div" ref="chartRef"></div>
          <div class="font_16 chart-title" v-if="isEchart">气象站数据图表</div>
        </div>
        <!-- 表格table -->
        <div class="flex flex_col warn-tables" v-else>
          <el-table
            v-if="tableData.length"
            :data="tableData"
            class="tables"
            :stripe="true"
            align="center"
            header-cell-class-name="header-cell"
            cell-class-name="table-cell"
          >
            <el-table-column
              type="index"
              label="序号"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="acquisitionTime"
              label="时间"
              width="180"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <!-- 动态显示类型 -->
            <el-table-column
              :label="item"
              align="center"
              show-overflow-tooltip
              v-for="(item, index) in tableCTypes"
              :key="index + item"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.tableList[item]">{{
                  scope.row.tableList[item]
                }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            class="pagination"
            layout="prev, pager, next"
            :page-size="ipagination.pageSize"
            :total="ipagination.total"
            :hide-on-single-page="true"
            :current-page.sync="ipagination.currentPage"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 暂无数据 -->
      <div
        class="table-empty flex flex_col flex_ju_c flex_a_c bottom-empty"
        v-else
      >
        <img
          class="table-noimg"
          src="@/assets/image/home/img_none.png"
          alt=""
        />
        <div class="table-emptyword">暂无数据</div>
      </div>
      <!-- 底部说明文字 -->
    </div>
  </div>
</template>

<script>
/**
 * @description 气象站数据分析
 */
import qs from "qs";
import tableMinin from "@/mixins/TableMinin";
import {
  prevDayTime,
  GetPreMonthDay,
  GetNextMonthDay,
  getFormatDate,
} from "../../times/moment";
export default {
  mixins: [tableMinin],
  data() {
    const self = this;
    return {
      isLine: true, // 是否显示折线图，代表的是是否有数据
      isEchart: false, // 页面上显示的是否是图表,
      isTranPage: true, // 是否传页码
      pageValue: "currentPage",
      isFillTime: true, // 时间后面是否补时分秒
      ifUseLoadBack: false,
      orgAllSelect: [], // 生产区域下拉选
      allOrgId: "", /// 分公司下面选中的orgid
      orgSelect: [], // 设备下拉选
      itemSelect: [], // 采集项下拉选
      tableCTypes: [],
      url: {
        list: self.$api.qxAnaList,
        lineChart: self.$api.qxLineChart,
      },
      sbList: [], //设备列表
      nowSBName: "", //选中设备名称
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
    };
  },
  mounted() {
    // this.makeChart()
    // 获取气象站数据
    // this.getOrgids()
    // this.loadData(1)

    // 获取头部下拉选
    if (this.isShowAllSelect) {
      // 获取上面的生产区域信息
      this.getAllOrgids();
    } else {
      this.getOrgids();
    }
  },
  methods: {
    // 下拉选择变化
    nowSBNameChange(val) {
      let changeArr = this.orgSelect.filter((item) => {
        return item.facId == val;
      });
      this.nowSBName = changeArr[0]["facName"];
      // 获取采集项组
      setTimeout(() => {
        // 获取采集项
        this.getItemsSelect(false);
      }, 300);
    },
    // 获取头部站点下拉选
    getOrgids(isFen = false, isReauestLine = true) {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        orgId: "",
      };
      if (isFen) {
        params.orgId = this.allOrgId;
      } else {
        params.orgId = userInfos.orgId;
      }
      this.$http
        .getAction(this.$api.qxfindDeviceByOrgId, params)
        .then((res) => {
          console.log(res);
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgSelect = datas || [];
            if (datas && datas.length) {
              this.isLine = this.isLine;
              this.sbList = datas;
              this.$set(this.queryParam, "deviceCode", datas[0]["facId"]);
              this.nowSBName = datas[0]["facName"];
              // 获取页面上相关的其它数据
              setTimeout(() => {
                // 获取采集项
                this.getItemsSelect(isReauestLine);
              }, 300);
            } else {
              if (isReauestLine) {
                this.isLine = false;
              }
              this.isLine = this.isLine;
              this.loading = false;
              this.$set(this.queryParam, "deviceCode", "");
              this.nowSBName = "";
              this.itemSelect = [];
              this.$set(this.queryParam, "list", []);
            }
          } else {
            this.orgSelect = [];
            this.$set(this.queryParam, "deviceCode", "");
            this.nowSBName = "";
            this.isLine = false;
            this.loading = false;
            this.itemSelect = [];
            this.$set(this.queryParam, "list", []);
          }
        })
        .catch(() => {
          this.orgSelect = [];
          this.$set(this.queryParam, "deviceCode", "");
          this.nowSBName = "";
          this.isLine = false;
          this.loading = false;
          this.itemSelect = [];
          this.$set(this.queryParam, "list", []);
        });
    },
    getAllOrgids() {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userOrg = this.getItem("wlwOrg") || {};
      let userOrgs = JSON.parse(userOrg);
      let userInfos = JSON.parse(userInfo);
      let params = {
        parentOrgId: userInfos.orgId,
        type: "2",
      };
      this.$http
        .getAction(this.$api.findChildOrgByParentOrgId, params)
        .then((res) => {
          console.log(res);
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgAllSelect = datas || [];
            if (datas && datas.length) {
              this.allOrgId = datas[0]["orgId"];
              this.getOrgids(true);
            } else {
              this.loading = false;
            }
          } else {
            this.orgSelect = [];
            this.loading = false;
          }
        })
        .catch(() => {
          this.orgSelect = [];
          this.loading = false;
        });
    },
    // 分公司网点下拉选选择
    changeAllOrg(val) {
      this.allOrgId = val;
      console.log(val);
      this.getOrgids(true, false);
    },
    // 获取采集项
    getItemsSelect(isSearch = true) {
      let params = {
        facId: this.queryParam.deviceCode,
      };
      this.$http
        .getAction(this.$api.qxgetDeviceItems, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data || [];
            if (datas && datas.length) {
              this.itemSelect = datas;

              console.log(this.itemSelect);
              this.$set(this.queryParam, "list", [datas[0]["itemCode"]]);
              if (isSearch) {
                this.loading = true;
                this.isLine = true;
                this.$set(this.queryParam, "list", [datas[0]["itemCode"]]);
                this.$nextTick(() => {
                  // 请求右下角折线图数据
                  // this.loadData(1)
                  if (this.isEchart) {
                    this.getLineData();
                  } else {
                    this.loadData(1);
                  }
                });
              } else {
                this.isLine = this.isLine;
                this.$set(this.queryParam, "list", []);
              }
            } else {
              this.isLine = false;
              this.itemSelect = [];
              this.loading = false;
              this.$set(this.queryParam, "list", []);
            }
          } else {
            this.isLine = false;
            this.itemsSelect = [];
            this.loading = false;
            this.$set(this.queryParam, "list", []);
          }
        })
        .catch(() => {
          this.isLine = false;
          this.itemsSelect = [];
          this.loading = false;
          this.$set(this.queryParam, "list", []);
        });
    },
    // 查询按钮点击
    searchClick_() {
      console.log(this.queryParam);
      this.$refs["ruleform"].validate((valid) => {
        if (valid) {
          console.log(this.queryParam.list);
          if (this.queryParam.list.length) {
            let miao = this.queryParam.startTime.split(" ")[1] || "00:00:00";
            let preMonthDay = new Date(
              GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6) +
                " " +
                miao
            ); //6个月之后的日期
            let startTimeCuo = new Date(this.queryParam.endTime).getTime();
            if (startTimeCuo >= preMonthDay.getTime()) {
              this.$message("选择时间跨度范围不允许超过6个月", "warning");
              this.loading = false;
              return false;
            }
            this.loading = true;
            // 请求折线图数据
            if (this.isEchart) {
              this.getLineData();
            } else {
              this.loadData(1);
            }
          } else {
            this.loading = false;
            this.$message("请至少选中一项参数", "warning");
          }
        } else {
          console.log("error submit!!");
          this.loading = false;
          return false;
        }
      });
    },
    // table数据请求回调
    loadBack(res) {
      let result = res.data;
      let datas = res.data.content;
      if (!datas.length) {
        this.isLine = false;
        return;
      }
      this.isLine = true;

      if (result.totalElements) {
        this.ipagination.total = Number(result.totalElements);
        this.ipagination.pageSize = result.size;
      } else {
        this.ipagination.total = 0;
        this.ipagination.pageSize = 10;
      }
      // 类型处理  ---- start
      let lenData = []; //类型数组
      datas.forEach((item, index) => {
        let tableList = {};
        item.list.forEach((key, ind) => {
          let lenIndex = lenData.findIndex((kk) => {
            if (
              key.acquisitionItemUnitCode &&
              key.acquisitionItemUnitCode != " " &&
              key.acquisitionItemUnitCode != ""
            ) {
              return (
                kk ==
                `${key.acquisitionItemName}(${key.acquisitionItemUnitCode})`
              );
            } else {
              return kk == `${key.acquisitionItemName}`;
            }
          });
          if (lenIndex > -1) {
          } else {
            if (
              key.acquisitionItemUnitCode &&
              key.acquisitionItemUnitCode != " " &&
              key.acquisitionItemUnitCode != ""
            ) {
              lenData.push(
                `${key.acquisitionItemName}(${key.acquisitionItemUnitCode})`
              );
            } else {
              lenData.push(`${key.acquisitionItemName}`);
            }
          }
          // 处理虫子类型和数量，便于图表的显示
          if (
            key.acquisitionItemUnitCode &&
            key.acquisitionItemUnitCode != " " &&
            key.acquisitionItemUnitCode != ""
          ) {
            tableList[
              `${key.acquisitionItemName}(${key.acquisitionItemUnitCode})`
            ] = key.acquisitionData || 0;
          } else {
            tableList[`${key.acquisitionItemName}`] = key.acquisitionData || 0;
          }
        });
        item.tableList = tableList;
      });
      this.tableCTypes = lenData;
      // console.log(this.tableCTypes);
      // 类型处理  ---- end
      // 表格数据赋值
      this.tableData = datas;

      // let xData = [] //时间数组
      // let lensData = [] //类型数组
      // let yDatas = [] //类型数量数组  （目标数据(类型（数量）)）
      // // let allData = [] //中转数组（时间（类型，数量））
      // datas.forEach((item, index) => {
      // 	xData.push(item.acquisitionTime)
      // 	// this.$set(allData, 'name', item)
      // 	item.list.forEach((key, val) => {
      // 		let lenIndex = lensData.findIndex((kk) => {
      // 			return kk == key.acquisitionItemName
      // 		})
      // 		if (lenIndex > -1) {
      // 		} else {
      // 			yDatas.push({
      // 				// animationDelay: 200,
      // 				// animationDuration: 3000,
      // 				name: key.acquisitionItemName,
      // 				// smooth: true,
      // 				// symbol: 'none',
      // 				// type: 'line',
      // 				data: [],
      // 				// time: item,
      // 			})
      // 			lensData.push(key.acquisitionItemName)
      // 		}
      // 	})
      // })

      // xData.sort(function (a, b) {
      // 	return b < a ? 1 : -1
      // })
      // xData.forEach((xitem, xindex) => {
      // 	lensData.forEach((litem, lindex) => {
      // 		yDatas[lindex]['data'][xindex] = 0
      // 		datas[xindex]['list'].forEach((ditem, dindex) => {
      // 			if (ditem.acquisitionItemName == litem) {
      // 				yDatas[lindex]['data'][xindex] = ditem.acquisitionData
      // 			}
      // 		})
      // 	})
      // })
      // console.log(yDatas)
    },
    // 折线图绘制
    makeChart(xdata, data1, data2) {
      // console.log(xdata)
      // console.log(data1)
      // console.log(data2)
      let that = this;
      let myChart = this.$echarts.init(this.$refs.chartRef);
      var num = "10%";
      if (data1.length === 1) {
        num = "4%";
      }
      if (data1.length === 2) {
        num = "5%";
      }
      if (data1.length === 3) {
        num = "5%";
      }
      if (data1.length > 3) {
        num = "5%";
      }
      let sbName = this.nowSBName;
      let option = {
        color: ["#2eaca8", "#3fa9ff", "#FAC858"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          padding: [11, 17],
          extraCssText:
            "box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;",

          transitionDuration: 0,
          formatter: function (param) {
            let axisValue = param[0].name;
            let infos = `
            <div style="text-align:left;">${sbName}</div>
            <div style="margin:12px 0">${axisValue}</div>
            `;
            param.forEach((item, index) => {
              let unit = "";
              if (
                data1[index].name &&
                data1[index].name != "" &&
                data1[index].name != " "
              ) {
                unit = data1[index].name.split("(")[1].split(")")[0];
              } else {
                unit = "";
              }
              infos += `
                <div style="margin:12px 0;color:${item.color}">${item.seriesName}：${item.value}${unit}</div>
              `;
            });

            return infos;
          },
        },
        dataZoom: {
          type: "inside",
          start: 0,
          end: 100,
        },
        legend: {
          type: "scroll",
          textStyle: {
            color: "#717374",
          },
          top: "4%",
          left: "center",
          width: "70%",
          icon: "rect",
          pageIconColor: "#01EDF6",
          pageIconInactiveColor: "#0F8088",
          pageTextStyle: {
            color: "#fff",
          },
          selectedMode: false,
        },
        grid: {
          left: num,
          //   left: "4%",
          right: "6%",
          bottom: "4%",
          top: "19%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xdata,
            nameTextStyle: {
              fontSize: 14,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#EDEDED",
                width: 2,
              },
            },
            axisLabel: {
              color: "#6B6B6B",
              fontSize: 14,
              lineHeight: 30,
            },
            boundaryGap: false,
          },
        ],
        yAxis: data1,
        series: data2,
      };
      myChart.clear();
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    // 获取折线图数据
    getLineData() {
      let params = Object.assign({}, this.queryParam);
      // 时间后面是否补时分秒，主要用于传参是页面显示不对应的问题
      if (params.startTime) {
        params.startTime = `${params.startTime} 00:00:00`;
        params.endTime = `${params.endTime} 23:59:59`;
      }
      let xAxis = [];
      let yAxis = [];
      let yName = "";
      let yUnit = "";
      this.$http
        .postAction(this.url.lineChart, params)
        .then(
          (res) => {
            if (res.meta.success) {
              if (res.data != {}) {
                // console.log(1);
                this.isLine = true;
                let resData = res.data;
                let lenData = []; //类型数组
                var data1 = [];
                var data2 = [];
                var xdata = [];
                let series = [];
                // x轴数据
                xdata = Object.keys(resData);
                if (!xdata.length) {
                  this.isLine = false;
                  return;
                }
                Object.keys(resData).forEach((key, indexx) => {
                  resData[key].forEach((item, index_) => {
                    let lenIndex = lenData.findIndex((kk) => {
                      return kk == item.acquisitionItemName;
                    });
                    if (lenIndex > -1) {
                    } else {
                      let codeUnits = "";
                      if (
                        item.acquisitionItemUnitCode &&
                        item.acquisitionItemUnitCode != " " &&
                        item.acquisitionItemUnitCode != ""
                      ) {
                        codeUnits = "(" + item.acquisitionItemUnitCode + ")";
                      } else {
                        codeUnits = "";
                      }
                      let aa = {
                        show: true,
                        name: codeUnits,
                        type: "value",
                        nameTextStyle: {
                          color: "#999",
                          fontSize: 14,
                          // align: 'center'
                          padding: [0, 30, 0, 0],
                        },
                        position: "left",
                        axisLine: {
                          show: true,
                          lineStyle: {
                            color: "#EDEDED",
                            width: 2,
                          },
                        },
                        minInterval: 1, //默认以1位分割单位，不允许出现小数点的情况
                        axisLabel: {
                          fontSize: 14,
                          color: "#999",
                        },
                        splitLine: {
                          show: true,
                          lineStyle: {
                            color: "#e9e9e9",
                          },
                        },
                        offset: index_ * 50,
                      };
                      data1.push(aa);
                      // if (index1_1 == 0) {
                      // 	aa.offset = 0
                      // 	data1.push(aa)
                      // }
                      // if (index1_1 == 1) {
                      // 	aa.offset = 50
                      // 	data1.push(aa)
                      // }
                      // if (index1_1 == 2) {
                      // 	aa.offset = 100
                      // 	data1.push(aa)
                      // }
                      series.push({
                        animationDelay: 200,
                        animationDuration: 3000,
                        name: item.acquisitionItemName,
                        smooth: true,
                        showSymbol: false,
                        symbolSize: 14,
                        type: "line",
                        data: [],
                        unit: item.acquisitionItemUnitCode,
                        yAxisIndex: index_,
                      });
                      lenData.push(item.acquisitionItemName);
                    }
                  });
                });
                // data1.forEach((item, index) => {
                //   item.offset = index * 50;
                // });
                // series.forEach((item, index) => {
                //   item.yAxisIndex = index;
                // });

                xdata.sort(function (a, b) {
                  return b < a ? 1 : -1;
                });

                xdata.forEach((xitem, xindex) => {
                  lenData.forEach((litem, lindex) => {
                    series[lindex]["data"][xindex] = 0;
                    resData[xitem].forEach((ditem, dindex) => {
                      if (ditem.acquisitionItemName == litem) {
                        series[lindex]["data"][xindex] = ditem.acquisitionData;
                      }
                    });
                  });
                });

                this.$nextTick(() => {
                  this.makeChart(xdata, data1, series);
                });
                // // y轴坐标数据
                // Object.keys(resData).forEach((item1, index1) => {
                // 	if (index1 == 0) {
                // 		resData[item1].forEach((item1_1, index1_1) => {
                // 			let aa = {
                // 				show: true,
                // 				name: '(' + item1_1.acquisitionItemUnitCode + ')',
                // 				type: 'value',
                // 				nameTextStyle: {
                // 					color: '#999',
                // 					fontSize: 14,
                // 					// align: 'center'
                // 					padding: [0, 30, 0, 0],
                // 				},
                // 				position: 'left',
                // 				axisLine: {
                // 					show: true,
                // 					lineStyle: {
                // 						color: '#EDEDED',
                // 						width: 2,
                // 					},
                // 				},
                // 				minInterval: 1, //默认以1位分割单位，不允许出现小数点的情况
                // 				axisLabel: {
                // 					fontSize: 14,
                // 					color: '#999',
                // 				},
                // 				splitLine: {
                // 					show: true,
                // 					lineStyle: {
                // 						color: '#e9e9e9',
                // 					},
                // 				},
                // 			}
                // 			if (index1_1 == 0) {
                // 				aa.offset = 0
                // 				data1.push(aa)
                // 			}
                // 			if (index1_1 == 1) {
                // 				aa.offset = 50
                // 				data1.push(aa)
                // 			}
                // 			if (index1_1 == 2) {
                // 				aa.offset = 100
                // 				data1.push(aa)
                // 			}
                // 		})
                // 	}
                // })
                // // data数据
                // let dataIndObj1 = {}
                // dataIndObj1.data = []
                // let dataIndObj2 = {}
                // dataIndObj2.data = []
                // let dataIndObj3 = {}
                // dataIndObj3.data = []
                // let dataLength = 0
                // Object.keys(resData).forEach((item2, index2) => {
                // 	if (index2 == 0) {
                // 		dataLength = resData[item2].length
                // 	}
                // 	resData[item2].forEach((item2_1, index2_2) => {
                // 		let sData
                // 		if (index2_2 == 0) {
                // 			dataIndObj1.data.push(item2_1.acquisitionData)
                // 			dataIndObj1.name = item2_1.acquisitionItemName
                // 			dataIndObj1.smooth = true
                // 			dataIndObj1.showSymbol = false
                // 			dataIndObj1.symbolSize = 14
                // 			dataIndObj1.type = 'line'
                // 			dataIndObj1.unit = item2_1.acquisitionItemUnitCode
                // 			dataIndObj1.yAxisIndex = 0
                // 		}
                // 		if (index2_2 == 1) {
                // 			dataIndObj2.data.push(item2_1.acquisitionData)
                // 			dataIndObj2.name = item2_1.acquisitionItemName
                // 			dataIndObj2.smooth = true
                // 			dataIndObj2.showSymbol = false
                // 			dataIndObj2.symbolSize = 14
                // 			dataIndObj2.type = 'line'
                // 			dataIndObj2.unit = item2_1.acquisitionItemUnitCode
                // 			dataIndObj2.yAxisIndex = 1
                // 		}
                // 		if (index2_2 == 2) {
                // 			dataIndObj3.data.push(item2_1.acquisitionData)
                // 			dataIndObj3.name = item2_1.acquisitionItemName
                // 			dataIndObj3.smooth = true
                // 			dataIndObj3.showSymbol = false
                // 			dataIndObj3.symbolSize = 14
                // 			dataIndObj3.type = 'line'
                // 			dataIndObj3.unit = item2_1.acquisitionItemUnitCode
                // 			dataIndObj3.yAxisIndex = 2
                // 		}
                // 	})
                // })
                // if (dataLength == 1) {
                // 	data2.push(dataIndObj1)
                // }
                // if (dataLength == 2) {
                // 	data2.push(dataIndObj1, dataIndObj2)
                // }
                // if (dataLength == 3) {
                // 	data2.push(dataIndObj1, dataIndObj2, dataIndObj3)
                // }
                // this.$nextTick(() => {
                // 	this.makeChart(xdata, data1, data2)
                // })
              }
            } else {
              this.isLine = false;
            }
          },
          (error) => {
            console.log("error");
            this.isLine = false;
          }
        )
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    // 导出
    exportDownLoad() {
      const _this = this;
      if (!this.isLine) {
        this.$message("暂无导出数据", "error");
        return;
      }
      // let params = {
      // 	dicts: JSON.stringify(this.queryParam.list),
      // 	start: this.queryParam.startTime,
      // 	end: this.queryParam.endTime,
      // 	org: this.queryParam.deviceCode,
      // }
      // this.$http.postAction('/sys/zhReport/exportQxzExcel', qs.stringify(params)).then((res) => {
      // 	window.layui.use('excel', function () {
      // 		var excel = layui.excel
      // 		var colConf = excel.makeColConfig(
      // 			{
      // 				//设置每列的宽度
      // 				A: 120,
      // 				Z: 120,
      // 			},
      // 			120
      // 		)
      // 		var rowConf = excel.makeRowConfig(
      // 			{
      // 				1: 30,
      // 			},
      // 			20
      // 		)
      // 		var fileName = _this.nowSBName + '数据表.xlsx'

      // 		if (res.meta.success == true) {
      // 			var dataRes = res.data
      // 			var title = dataRes.title
      // 			var dataList = dataRes.data
      // 			var titleList = dataRes.titleList
      // 			dataList.unshift(title)
      // 			var data = excel.filterExportData(dataList, titleList)
      // 			excel.exportExcel(
      // 				{
      // 					sheet1: data,
      // 				},
      // 				fileName,
      // 				'xlsx',
      // 				{
      // 					extend: {
      // 						'!cols': colConf,
      // 					},
      // 				}
      // 			)
      // 			// parent.layer.close(index);
      // 		} else {
      // 			_this.$message('暂无数据导出!', 'warn')
      // 			return
      // 		}
      // 	})
      // })

      let params = Object.assign({}, this.queryParam);
      // 判断是否传递页码
      params.currentPage = 1;
      params.pageSize = this.ipagination.total;
      // 时间后面是否补时分秒，主要用于传参是页面显示不对应的问题
      if (params.startTime) {
        params.startTime = `${params.startTime} 00:00:00`;
        params.endTime = `${params.endTime} 23:59:59`;
      }

      let arr = ["序号", "时间", "设备名称"];
      let filterDefaultVal = ["index", "acquisitionTime", "deviceName"];

      this.$http
        .postAction(this.url.list, params)
        .then((res) => {
          console.log(res);
          if (res.meta.success) {
            let datas = res.data.content;
            let lenData = []; //类型数组
            let itemCode = [];
            if (datas.length) {
              datas.forEach((item, index) => {
                item.list.forEach((key, ind) => {
                  let lenIndex = lenData.findIndex((kk) => {
                    if (
                      key.acquisitionItemUnitCode &&
                      key.acquisitionItemUnitCode != " " &&
                      key.acquisitionItemUnitCode != ""
                    ) {
                      return (
                        kk ==
                        `${key.acquisitionItemName}(${key.acquisitionItemUnitCode})`
                      );
                    } else {
                      return kk == `${key.acquisitionItemName}`;
                    }
                  });
                  if (lenIndex > -1) {
                  } else {
                    if (
                      key.acquisitionItemUnitCode &&
                      key.acquisitionItemUnitCode != " " &&
                      key.acquisitionItemUnitCode != ""
                    ) {
                      lenData.push(
                        `${key.acquisitionItemName}(${key.acquisitionItemUnitCode})`
                      );
                    } else {
                      lenData.push(`${key.acquisitionItemName}`);
                    }

                    itemCode.push(key.acquisitionItem);
                  }
                  item[key.acquisitionItem] = key.acquisitionData;
                });
                item.index = index + 1;
                item.deviceName = this.nowSBName;
              });
              datas.sort(function (a, b) {
                let obj1 = a["acquisitionTime"];
                let obj2 = b["acquisitionTime"];
                const val1 = Math.floor(new Date(obj1).getTime() / 1000);
                const val2 = Math.floor(new Date(obj2).getTime() / 1000);
                return val2 - val1;
              });
              let tableData = datas;
              let fileHead = arr.concat(lenData);
              let filterVal = filterDefaultVal.concat(itemCode);
              console.log(tableData);
              this.$nextTick(() => {
                this.handleExportXls(
                  tableData,
                  fileHead,
                  filterVal,
                  this.nowSBName + "数据分析"
                );
              });
            } else {
              this.$message("暂无导出数据", "error");
            }
          } else {
            this.$message("数据请求失败，请稍后重试", "error");
          }
        })
        .finally((err) => {})
        .catch(() => {
          this.$message("数据请求失败，请稍后重试", "error");
        });
    },
    // 切换到图表
    toChart() {
      this.isEchart = !this.isEchart;
      this.loading = true;
      if (this.isEchart) {
        this.getLineData();
      } else {
        this.loadData(1);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// 下面的折线图
.qxapage {
  height: 100%;
  .chart-all {
    margin-top: 0.15rem;
    width: 20.07rem;
    flex: 1;
    min-height: 610px;
    // height: 9.19rem;
    background: #ffffff;
    border-radius: 0.19rem;
    position: relative;
    // 导出按钮
    .btn-export {
      width: 0.75rem;
      height: 0.45rem;
      color: #42b5b2;
      border: 1px solid #2daea9;
      border-radius: 4px;
      font-size: 0.17rem;
      position: absolute;
      top: 0.2rem;
      right: 0.5rem;
      cursor: pointer;
      z-index: 20;
      div {
        width: 0.75rem;
        height: 0.45rem;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 0.25rem;
        }
        &.export-icon2 {
          border-left: 1px solid #2daea9;
        }
      }
    }
    .chart-div {
      width: 20.07rem;
      height: 96%;
    }
    .bottom-empty {
      height: 100%;
      width: 100%;
    }
    .chart-title {
      color: #333;
    }
    // 表格
    .warn-tables {
      position: relative;
      top: 0.85rem;
      padding-bottom: 0;
      margin-top: 0;
      flex: 1;
      .tables {
        width: 100%;
        // height: 6.7rem;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }
}
</style>
